import { User } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Avatar component - displays user profile photo or initials fallback
 * 
 * @param {string} name - User's name (used for initials fallback)
 * @param {string} photo - Profile photo filename
 * @param {string} size - Size variant: 'xs', 'sm', 'md', 'lg', 'xl'
 * @param {string} className - Additional CSS classes
 */
export default function Avatar({ name, photo, size = 'md', className = '' }) {
  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl'
  };

  const photoUrl = photo ? `${API_URL}/uploads/photos/${photo}` : null;
  const initials = name ? name.charAt(0).toUpperCase() : '?';

  return (
    <div 
      className={`rounded-full overflow-hidden bg-hub-100 text-hub-600 flex items-center justify-center font-medium ${sizeClasses[size]} ${className}`}
    >
      {photoUrl ? (
        <img 
          src={photoUrl} 
          alt={name || 'User'} 
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback to initials if image fails to load
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      ) : null}
      <span 
        className={`${photoUrl ? 'hidden' : 'flex'} items-center justify-center w-full h-full`}
      >
        {initials}
      </span>
    </div>
  );
}
